import { render } from "./PhotoSwipe.vue?vue&type=template&id=281752fc&bindings={\"pswp\":\"data\",\"init\":\"options\",\"push\":\"options\",\"close\":\"options\"}"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js"
script.render = render

export default script